import { useContext } from "react";
import { GridLegacy as Grid } from "@mui/material";
import { IPreferences } from "../../logic/api";
import EditableField, {
    EditableFieldTypes,
} from "../../components/editable/EditableField/EditableField";
import EditableGroup, {
    EditableGroupType,
} from "../../components/editable/EditableGroup/EditableGroup";
import NotchedCard from "../../components/cards/NotchedCard/NotchedCard";
import { SessionContext } from "../../utility/useSession";
import styles from "./styles";
import { useTranslation } from "react-i18next";

interface DriverShiftTrackerSettingsProps {
    onSave: (data: Partial<IPreferences>) => Promise<boolean>;
}

export const DriverShiftTrackerSettings = ({ onSave }: DriverShiftTrackerSettingsProps) => {
    const session = useContext(SessionContext);
    const { t } = useTranslation();

    if (!session.current.site) {
        return null;
    }

    return (
        <Grid item xs={12}>
            <NotchedCard label={t("settings.driverShiftTracker")} style={styles.card}>
                <EditableGroup<IPreferences>
                    id="driverShiftTrackerSettings"
                    editType={EditableGroupType.switchableEditing}
                    data={session.current.site.preferences}
                    onDataChanged={(data) => onSave({
                        driver_shift_tracker_enabled: data.driver_shift_tracker_enabled,
                    })}
                    testId="driver-shift-tracker-settings"
                >
                    <Grid container>
                        <Grid item sm={2} xs={6}>
                            <EditableField<IPreferences, boolean>
                                useFullWidthWhenEditing={false}
                                inputType={EditableFieldTypes.switch}
                                label={t("reports.enabled")}
                                onProvide={(data) =>
                                    Boolean(data.driver_shift_tracker_enabled)
                                }
                                onChange={(data, value) =>
                                    data.driver_shift_tracker_enabled = Boolean(value)
                                }
                                testId="settings-driver-shift-tracker-enabled-switch"
                            />
                        </Grid>
                    </Grid>
                </EditableGroup>
            </NotchedCard>
        </Grid>
    );
};

